module.exports = __webpack_public_path__ + "static/media/access-management.2a761162.jpg";